import {ChangeDetectionStrategy, Component, Inject, Optional} from '@angular/core';
import {Widget} from '../../components/layout/widget/widget';
import {CellSizeObserverService} from '../../pages/dashboard/layout/cell/cell-size-observer.service';
import {IS_DETACHED_WIDGET} from '../../pages/widget-page/detached-widget-injection';
import {EmptyWidget} from './empty-widget';

@Component({
    selector:        'empty-widget',
    templateUrl:     './empty-widget.component.html',
    styleUrls:       ['./empty-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      false
})
export class EmptyWidgetComponent {

    public readonly resize$ = this.cellSizeObserverService.resize$;

    constructor(
        @Inject(Widget)
        public widget: EmptyWidget,

        @Optional()
        @Inject(IS_DETACHED_WIDGET)
        public isDetachedWidget: boolean,

        private cellSizeObserverService: CellSizeObserverService
    ) {}

}
